import { render, staticRenderFns } from "./itemGroupTwo.vue?vue&type=template&id=e454e124&"
import script from "./itemGroupTwo.vue?vue&type=script&lang=js&"
export * from "./itemGroupTwo.vue?vue&type=script&lang=js&"
import style0 from "./itemGroupTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VListGroup,VListItemContent,VListItemIcon,VListItemTitle,VSubheader})
